import { Service, inject } from '@angular/core'
import {
  CreateReservationBlueprintBody,
  DeleteEntityResponse,
  EditReservationBlueprintBody,
  GetManagedReservationBluperintsResponse,
  ManagedReservationBlueprint,
  SetReservationBlueprintActiveBody,
} from '@seiri/shared/common'
import { ApiService } from '../api.service'

@Service()
export class ManageReservationBlueprintApiService {
  private readonly api = inject(ApiService)

  getManagedReservationBluperints(entityId: string, init?: RequestInit) {
    return this.api.protectedFetchJson<GetManagedReservationBluperintsResponse>(
      `manage/entities/${entityId}/reservation-blueprints`,
      { ...init },
    )
  }

  getManagedReservationBlueprint(entityId: string, reservationBlueprintId: string, init?: RequestInit) {
    return this.api.protectedFetchJson<ManagedReservationBlueprint>(
      `manage/entities/${entityId}/reservation-blueprints/${reservationBlueprintId}`,
      { ...init },
    )
  }

  createReservationBlueprint(entityId: string, body: CreateReservationBlueprintBody, init?: RequestInit) {
    return this.api.protectedFetchJson<ManagedReservationBlueprint>(
      `manage/entities/${entityId}/reservation-blueprints`,
      {
        method: 'POST',
        body: JSON.stringify(body),
        ...init,
      },
    )
  }

  editReservationBlueprint(
    entityId: string,
    reservationBlueprintId: string,
    body: EditReservationBlueprintBody,
    init?: RequestInit,
  ) {
    return this.api.protectedFetchJson<ManagedReservationBlueprint>(
      `manage/entities/${entityId}/reservation-blueprints/${reservationBlueprintId}`,
      {
        method: 'PATCH',
        body: JSON.stringify(body),
        ...init,
      },
    )
  }

  setReservationBlueprintActive(
    entityId: string,
    reservationBlueprintId: string,
    body: SetReservationBlueprintActiveBody,
    init?: RequestInit,
  ) {
    return this.api.protectedFetchJson<ManagedReservationBlueprint>(
      `manage/entities/${entityId}/reservation-blueprints/${reservationBlueprintId}/active`,
      {
        method: 'PUT',
        body: JSON.stringify(body),
        ...init,
      },
    )
  }

  deleteReservationBlueprint(entityId: string, reservationBlueprintId: string, init?: RequestInit) {
    return this.api.protectedFetchJson<DeleteEntityResponse>(
      `manage/entities/${entityId}/reservation-blueprints/${reservationBlueprintId}`,
      {
        method: 'DELETE',
        ...init,
      },
    )
  }
}
